import { useCallback, useState } from "react";
// import {
//   ConnectionLifecycle,
//   GameLifecycle,
//   IGameData,
//   PauseHandlerHook,
// } from "./types";
// import { ConnectFN, Contextable } from "./types";

export const useConnectionCallback = (dispatch) => {
  const callback = useCallback(() => {
    // if (auth.token) {
    //   let payload = {
    //     action: "connectionValidation",
    //     msg: auth.token,
    //   };
    //   sendMessage(payload);
    // }
    dispatch({ type: "CONNECTED" });
  }, []);
  return callback;
};

export const useMessageCallback = (dispatch) => {
  const callback = useCallback(
    (resp) => {
      // if (JSON.parse(resp)) {
      const data = JSON.parse(resp.data);
      if (data.context) dispatch({ type: data.context, payload: data.data });
      // }
    },
    [dispatch]
  );
  return callback;
};

export const useConnectionPauseHandler = (state, dispatch) => {
  const [connectFn, setConnectFn] = useState(null);

  const disconnectCallback = useCallback(() => {
    if (state.connectionStatus !== "RESUMED")
      dispatch({ type: "DISCONNECTED" });
  }, [dispatch, state.connectionStatus]);

  const pauseCallback = useCallback(() => {
    if (
      state.gameStatus === "STOPPED" ||
      state.connectionStatus === "PRE_CREATED" ||
      state.connectionStatus === "PAUSED"
    ) {
      // disconnection is expected, or an error is prevting the connection from reconnecting

      dispatch({ type: "DISCONNECTED" });
    } else if (state.connectionStatus === "REFRESHING") {
      dispatch({ type: "REFRESH_FAILED" });
    } else if (state.connectionStatus !== "GOING_AWAY") {
      // connection is unexpected, and not attempting reconnection

      dispatch({ type: "SESSION_PAUSED" });
      if (connectFn) connectFn();
      setTimeout(disconnectCallback, 30 * 1000);
    }
  }, [
    disconnectCallback,
    dispatch,
    connectFn,
    state.gameCode,
    state.playerId,
    state.connectionStatus,
    state.gameStatus,
  ]);

  const registerConnectFunction = useCallback((fn) => {
    setConnectFn(() => fn); // do this to avoid confusing the react dispatch function
  }, []);

  return [registerConnectFunction, pauseCallback];
};
